import { DELAY_TO_SHOW, STORAGE_KEY_HISTORY, STORAGE_KEY_LAST_SHOWN_ID } from './constants';

type TournamentHistory = Record<number, { lastShown: number; isClosed: boolean }>;

export const tournamentsStorageApi = {
  getTournamentHistory(): TournamentHistory {
    try {
      const raw = localStorage.getItem(STORAGE_KEY_HISTORY);
      if (!raw) return {};
      return JSON.parse(raw) as TournamentHistory;
    } catch (e) {
      console.error('Error reading tournament history:', e);
      return {};
    }
  },

  updateTournamentHistory(id: number, updates: Partial<{ lastShown: number; isClosed: boolean }>) {
    try {
      const history = this.getTournamentHistory() || {};
      const existing = history[id] || { lastShown: 0, isClosed: false };
      history[id] = { ...existing, ...updates };
      localStorage.setItem(STORAGE_KEY_HISTORY, JSON.stringify(history));
    } catch (e) {
      console.error(`Error updating tournament ${id}:`, e);
    }
  },

  getLastShownId(): number | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY_LAST_SHOWN_ID);
      return raw ? parseInt(raw, 10) : null;
    } catch (e) {
      console.error('Error reading last shown ID:', e);
      return null;
    }
  },

  setLastShownId(id: number) {
    try {
      localStorage.setItem(STORAGE_KEY_LAST_SHOWN_ID, id.toString());
    } catch (e) {
      console.error('Error setting last shown ID:', e);
    }
  },

  markAsShown(id: number) {
    const history = tournamentsStorageApi.getTournamentHistory();
    const item = history[id];
    const now = Date.now();
    if (!item || item.lastShown + DELAY_TO_SHOW < now) {
      this.setLastShownId(id);
      this.updateTournamentHistory(id, { lastShown: now });
    }
  },

  markAsClosed(id: number) {
    this.updateTournamentHistory(id, { isClosed: true });
  }
};
